import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {GameService} from "../../../serverService/gameService/GameService";
import RaikoCustomEditor2 from "../../../raikoComponents/raikoEditor/RaikoCustomEditor2";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function GameDescription({gameId}) {

    const [actionButtonLoading, setActionButtonLoading] = useState(false);
    const [gameDescription, setGameDescription] = useState([]);

    const service = new GameService()

    const loading = new LoadingHelper(useLoadingDispatcher())


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameDescriptionFromServer()
        }
    }, [gameId]);

    function getGameDescriptionFromServer() {
        loading.show()
        service.getGameDescription(gameId)
            .then((
                {
                    gameDescriptionContent
                }) => {
                setGameDescription(gameDescriptionContent)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateGameDescription() {

        if (gameDescription.length > 0) {
            setActionButtonLoading(true)
            service.updateGameDescription(gameId, gameDescription)
                .then(
                    response => {
                        showSuccessMessage("توضیحات بازی با موفقیت بروزرسانی شد.")
                    }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                setActionButtonLoading(false)
            })
        } else {
            showWarningMessage("لطفا ابتدا توضیحات بازی را وارد نمایید.")
        }


    }


    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"توضیحات بازی"}
                    hasActionButton
                    actionButtonLoadingState={actionButtonLoading}
                    actionButtonOnclick={handleUpdateGameDescription}
                >
                    <RaikoCustomEditor2
                        value={gameDescription}
                        setValue={setGameDescription}
                    />

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}